import React, { useCallback, useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import { toast } from "react-toastify";
import * as api from "../../redux/api";
import { reactIcons } from "../../utils/icons";
import { debounce } from "lodash";
import CustomNoRowsOverlay from "../../utils/styles";
import { useNavigate } from "react-router-dom";
import OrganizationModal from "../../components/modals/OrganizationModal";
import BackButton from "../../components/BackButton";

import Tooltip from "@mui/material/Tooltip";

const KycUserListing = () => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [activeType, setActiveType] = useState("All");
  const [queryParams, setQueryParams] = useState({});
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [rejectReason, setRejectReason] = useState("");

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    setActiveType(selectedValue);
    let queryParam = {};

    if (selectedValue === "All") {
      queryParam = {}; // no filtering for "All"
    } else {
      queryParam = { kYCStatus: selectedValue };
    }

    setQueryParams(queryParam);
  };

  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 9
  });
  const [rowCountState, setRowCountState] = useState(0);

  const columns = [
    {
      field: "_id",
      headerName: "S.No.",
      type: "number",
      headerAlign: "center",
      align: "center",
      width: 100
    },
    {
      field: "name",
      headerName: "Name",
      type: "string",
      flex: 2
    },
    {
      field: "emailAddress",
      headerName: "Email",
      type: "string",
      flex: 3,
      valueFormatter: (params) => (params.value ? params.value : "-")
    },
    // {
    //   field: "phoneNumber",
    //   headerName: "Mobile",
    //   type: "number",
    //   headerAlign: "left",
    //   align: "left",
    //   flex: 2,
    //   valueFormatter: (params) => (params.value ? params.value : "-")
    // },
    {
      field: "type",
      headerName: "Type",
      type: "string",
      flex: 2
    },
    {
      field: "kycStatus",
      headerName: "Status",
      type: "string",
      flex: 2
    },
    // {
    //   field: "createdAt",
    //   headerName: "Date & Time",
    //   type: "string",
    //   flex: 3,
    //   valueFormatter: (params) => {
    //     if (!params.value) return "-";
    //     const date = new Date(params.value);
    //     return date.toLocaleString("en-US", {
    //       hour: "numeric",
    //       minute: "2-digit",
    //       // second: "2-digit",
    //       hour12: true,
    //       year: "numeric",
    //       month: "2-digit",
    //       day: "2-digit"
    //     });
    //   }
    // },
    {
      field: "registrationStatus",
      headerName: "Organisation Name",
      type: "string",
      flex: 2
    },
    {
      field: "View",
      headerName: "View",
      type: "actions",
      flex: 2,
      getActions: (params) => {
        return [
          <div
            key={params.row.id}
            onClick={() => {
              navigate(`/kyc/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
          >
            {reactIcons.eyeVisible}
          </div>
        ];
      }
    },

    // {
    //   field: "action",
    //   headerName: "Action",
    //   type: "actions",
    //   flex: 3,
    //   renderCell: (params) => {
    //     const status = params.row.verificationStatus;

    //     if (activeType === "All" || !status) {
    //       return (
    //         <div className="flex gap-2">
    //           <button
    //             onClick={() => handleVerify(params.row)}
    //             className="bg-green-600 px-4 py-2 text-white rounded-lg"
    //           >
    //             Verify
    //           </button>
    //           <button
    //             onClick={() => {
    //               setRejectModalOpen(true);
    //               setSelectedUser(params.row);
    //             }}
    //             className="bg-red-600 px-4 py-2 text-white rounded-lg"
    //           >
    //             Reject
    //           </button>
    //         </div>
    //       );
    //     }
    //     // if (activeType === "All") {
    //     //   return params.row.kycStatus;
    //     // }
    //     if (activeType === "Verified") {
    //       return (
    //         <span className="text-green-600 font-semibold pl-2">Verified</span>
    //       );
    //     }

    //     if (activeType === "Rejected") {
    //       return (
    //         <span className="text-red-600 font-semibold pl-2">Rejected</span>
    //       );
    //     }

    //     // Fallback for any unexpected status value
    //     return <span>{status}</span>;
    //   }
    // }
    {
      field: "action",
      headerName: "Action",
      type: "actions",
      flex: 3,
      renderCell: (params) => {
        const status = params.row.kycStatus || "Reject";

        if (status === "Pending") {
          return (
            <div className="flex gap-2">
              <button
                onClick={() => handleVerify(params.row)}
                className="bg-green-600 px-4 py-2 text-white rounded-lg"
              >
                Verify
              </button>
              <button
                onClick={() => {
                  setRejectModalOpen(true);
                  setSelectedUser(params.row);
                }}
                className="bg-red-600 px-4 py-2 text-white rounded-lg"
              >
                Reject
              </button>
            </div>
          );
        }

        if (status === "Rejected") {
          return (
            <Tooltip
              title={
                params.row.user.meta.organizationRejectionReasons ||
                "No rejection reason "
              }
              arrow
            >
              <span className="text-red-600 font-semibold pl-2">Rejected</span>
            </Tooltip>
          );
        }

        if (status === "Approved") {
          return (
            <span className="text-green-600 font-semibold pl-2">Approved</span>
          );
        }
        // Fallback
        return <span>{status}</span>;
      }
    }
  ];

  const handleReject = async (user, reason) => {
    try {
      await api.verifyOrRejectKyc(user.userId || user.userId, {
        status: "Rejected",
        reasons: rejectReason
      });
      toast.success(`${user.name} has been rejected.`);
      setRejectModalOpen(false);
      setSelectedUser(null);
      setRejectReason("");
      debouncedFetchUsers();
    } catch (error) {
      toast.dismiss();
      toast.error(error.response?.data?.message || "Failed to reject user.");
      console.error(error);
    }
  };

  const handleVerify = async (user) => {
    try {
      await api.verifyOrRejectKyc(user.userId || user._userId, {
        status: "Approved"
      });
      toast.success(`${user.name} has been verified.`);
      debouncedFetchUsers();
    } catch (error) {
      toast.dismiss();
      toast.error(error.response?.data?.message || "Failed to verify user.");
      console.error(error);
    }
  };

  const getUserData = async () => {
    setIsLoading(true);
    const response = await api.getUsers(
      paginationModel.page,
      paginationModel.pageSize,
      searchText,
      queryParams,
      "",
      "user"
    );
    const { data, status } = response;
    if (status >= 200 && status < 300) {
      setIsLoading(false);
      setRowCountState(data.count);
      setRows(
        data.data.map((item, index) => {
          return {
            ...item,
            _id: paginationModel.page * 10 + index + 1,
            verificationStatus: item.verificationStatus || "Pending"
          };
        })
      );
    } else {
      setIsLoading(false);
      toast.error(data.message);
    }
  };
  // eslint-disable-next-line
  const debouncedFetchUsers = useCallback(
    debounce(() => getUserData(), 500),
    [paginationModel, queryParams, searchText]
  );

  useEffect(() => {
    debouncedFetchUsers();
    return () => {
      debouncedFetchUsers.cancel();
    };
  }, [debouncedFetchUsers]);

  return (
    <>
      <div className="w-full mt-10 data-grid">
        <div className="mb-6">
          <div className="flex justify-between items-center">
            <div className="flex gap-2 items-center">
              <BackButton />
              <h4>KYC Listing</h4>
            </div>
            <div className="flex flex-col justify-end items-end gap-2">
              <div className="flex gap-2">
                <div className="relative">
                  <input
                    className="w-[250px] h-[45px] bg-transparent"
                    type="text"
                    value={searchText}
                    placeholder="Search by name, email"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <span className="absolute text-18 top-[calc(50%-9px)] right-2">
                    {reactIcons.search}
                  </span>
                </div>
                <div className="form-select-custom">
                  <select
                    className="min-w-[150px] w-full h-[45px] bg-white"
                    name="usersType"
                    id="usersType"
                    value={activeType}
                    onChange={handleSelectChange}
                  >
                    <option value="All">All</option>
                    <option value="Pending">Pending</option>
                    <option value="Approved">Verified</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                  <span className="ay-center right-2 text-zinc-500 text-[20px] pointer-events-none">
                    {reactIcons.arrowDown}
                  </span>
                </div>
              </div>
              {rejectModalOpen && selectedUser && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                  <div className="bg-white p-6 rounded-lg w-[400px]">
                    <h2 className="text-xl font-semibold mb-4">Reject User</h2>
                    <p className="mb-2">
                      Are you sure you want to reject{" "}
                      <strong>{selectedUser.name}</strong>?
                    </p>
                    <label className="block mb-2 font-medium">
                      Reason for rejection:
                    </label>
                    <textarea
                      className="w-full border border-gray-300 rounded p-2"
                      rows="4"
                      value={rejectReason}
                      onChange={(e) => setRejectReason(e.target.value)}
                      placeholder="Write your reason here..."
                    ></textarea>
                    <div className="flex justify-end gap-3 mt-6">
                      <button
                        className="px-4 py-2 bg-gray-300 rounded"
                        onClick={() => {
                          setRejectModalOpen(false);
                          setSelectedUser(null);
                          setRejectReason("");
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="px-4 py-2 bg-red-600 text-white rounded disabled:opacity-50"
                        disabled={!rejectReason.trim()}
                        onClick={() => handleReject(selectedUser, rejectReason)}
                      >
                        Confirm Reject
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="h-[600px] w-full !text-black mt-4">
          <DataGrid
            loading={isLoading}
            rows={rows}
            getRowId={(row) => row._id}
            getEstimatedRowHeight={() => 52}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10
                }
              }
            }}
            rowCount={rowCountState}
            pageSizeOptions={[10]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            slots={{
              loadingOverlay: LinearProgress,
              noRowsOverlay: CustomNoRowsOverlay
            }}
            disableColumnMenu
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-row:hover": {
                cursor: "default"
              },
              "& .MuiDataGrid-root": {
                color: "black"
              },
              "& .MuiDataGrid-cell": {
                color: "black"
              },
              "& .MuiDataGrid-columnHeaders": {
                color: "black"
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "black"
              },
              "& .MuiDataGrid-columnHeader": {
                color: "black"
              },
              "& .MuiTablePagination-root": {
                color: "white"
              },
              "& .MuiSvgIcon-root": {
                color: "white"
              }
            }}
          />
        </div>
      </div>
      {open && (
        <OrganizationModal
          open={open}
          handleClose={() => {
            setOpen(false);
            debouncedFetchUsers();
          }}
        />
      )}
    </>
  );
};

export default KycUserListing;
